import type { TableColumn } from '../types';

const escapeCsvCell = (value: string): string => {
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
};

const formatCsvCell = (raw: unknown): string => {
  if (raw == null) return '';
  if (typeof raw === 'string' || typeof raw === 'number' || typeof raw === 'boolean') {
    return String(raw);
  }
  return JSON.stringify(raw);
};

/** Build CSV from a metric `table` payload (column labels as headers, row key order). */
export const metricTableToCsv = (table?: {
  columns: TableColumn[];
  rows: Record<string, unknown>[];
}): string | null => {
  if (!table?.columns?.length || !table.rows?.length) {
    return null;
  }

  const headerLine = table.columns.map(col => escapeCsvCell(col.label)).join(',');
  const dataLines = table.rows.map(row =>
    table.columns.map(col => escapeCsvCell(formatCsvCell(row[col.key]))).join(','),
  );

  return [headerLine, ...dataLines].join('\n');
};

export const downloadCsvFile = (csvContent: string, fileName: string) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName.endsWith('.csv') ? fileName : `${fileName}.csv`;
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const toCsvFileName = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'export';
